import { Injectable, inject } from '@angular/core';
import { ApiService } from '@core/services';
import { Roles } from '../models';
import { Observable } from 'rxjs';
import { BussinesService } from '../../public/services/bussines.service';

@Injectable({
  providedIn: 'root',
})
export class RoleService {
  private apiService = inject(ApiService);
  private bussinesService = inject(BussinesService);

  storeRole(data: Roles) {
    return this.apiService.store(
      `role?name=${data.name}&rolecode=${data.rolecode}&description=${
        data.description
      }&recurrence=${data.recurrence}&type=${
        data.type
      }&businessid=${this.bussinesService.getBussinesId()}`,
      undefined
    );
  }

  deleteRole(id: number) {
    return this.apiService.delete('role', id);
  }

  getRoles(): Observable<Roles[]> {
    return this.apiService.getAll('role');
  }

  getRole(id: number): Observable<Roles> {
    return this.apiService.getById('role', id);
  }

  updateRole(data: Roles, id: number) {
    return this.apiService.update(
      `role/${id}?name=${data.name}&rolecode=${data.rolecode}&description=${data.description}&recurrence=${data.recurrence}&type=${data.type}`,
      undefined,
      id
    );
  }

  getRolesItems(): Observable<any> {
    return this.apiService.getAll('role');
  }
}
